module.exports = __webpack_public_path__ + "media/images/plans/plan-detail-icon-planner-face-eb71f576e2d5788d6f1edc6727d98e1f.png";